// extracted by mini-css-extract-plugin
module.exports = {"pt-task-order-detail":"pt-task-order-detail-ec4b71846789e4c13957061b9cfa5bc5","fixedBox":"fixedBox-e65702e08ebb29f911b7d788872ec407"};